import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    records: []
  },
  mutations: {
    setRecords(state, payload) {
      state.records = payload;
    }
  },
  actions: {
    getRecords({ commit }, query) {
      api.getRecords(query).then(({ data }) => {
        commit('setRecords', data);
      });
    }
  }
};

appStore.registerModule('orderTaskUserAmountRecord', store);
